var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "21.25 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M34.9 8.4C36.8 6.3 39.5 5 42.5 5c5.5 0 10 4.5 10 10v2.3M54.9 17.4H30.1v11.5c0 4.5 3.7 8.2 8.2 8.2h8.5c4.5 0 8.2-3.7 8.2-8.2V17.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_green",
    d: "M51.1 20.8H34c-.4 0-.7.3-.7.7v6.9c0 2.9 2.3 5.2 5.2 5.2h7.9c2.9 0 5.2-2.3 5.2-5.2v-6.9c.2-.4-.2-.7-.5-.7zm-7.4 9.3c0 .6-.4 1-1 1s-1-.4-1-1v-5.6c0-.6.4-1 1-1s1 .4 1 1v5.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.76ff381654a1ff81e907fb60edbcbba0.svg";
export { ForwardRef as ReactComponent };